import { render, staticRenderFns } from "./ProductDetailModuleView.vue?vue&type=template&id=45a2fea1&scoped=true"
import script from "./ProductDetailModuleView.vue?vue&type=script&lang=js"
export * from "./ProductDetailModuleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2fea1",
  null
  
)

export default component.exports